$(document).on('click','.sub .btn:not(.continue)',function(e){ //PROFILE BUTTON FUNCTIONS - EDIT, etc.
    e.preventDefault();
    console.log('USING _WYSIWYG.JS!!!');
    var $this=$(this);
    if($this.hasClass('changepw') || $this.hasClass('addRow') || $this.hasClass('disabled') ||$this.hasClass('profile-add-skill')){
        return;
    }
    if (tinyMCE) {
        tinyMCE.triggerSave();
    }
});
function reset_wysiwyg(){

    if (tinymce) {
        tinymce.remove('.wysiwyg');
    }
    if ($('.wysiwyg').length) {
        tinyMCE.init({
            selector: '.wysiwyg',
            setup: function (editor) {
                // defaults if globals not set
                if (typeof window.charLimit === 'undefined') window.charLimit = 4000;
                if (typeof window.wordLimit === 'undefined') window.wordLimit = 5000;

                function normalizeText(s) {
                    return (s || '')
                        .replace(/\u00a0/g, ' ') // NBSP -> space
                        .replace(/\s+/g, ' ')    // collapse whitespace
                        .trim();
                }

                function checkCounts() {
                    const el      = editor.getElement();
                    const $form   = $(el).closest('form');
                    const $scope  = $(el).closest('.fw-editor');
                    const $count  = $scope.find('.the-count');
                    const $save   = $form.find('.primary.save');
                    const $acts   = $form.find('.wbl-actions');

                    const textContent = normalizeText(editor.getBody().textContent);
                    const content     = editor.getContent(); // with HTML

                    if ($scope.find('.char-count').length) {
                        $count.text(textContent.length);

                        if (window.charLimit !== -1 && textContent.length > window.charLimit) {
                            $count.addClass('error');
                            $save.addClass('disabled exceeded-limit').attr('disabled', true);

                            $form.find('.errors.exceeded-limit').remove();
                            const err = `<div class="errors exceeded-limit">
              <p class="error">You have exceeded the limit of ${window.charLimit} characters. Please review your content for length.</p>
            </div>`;
                            if ($acts.length) $acts.after(err); else $form.append(err);
                        } else {
                            $count.removeClass('error');

                            if (!$('.the-count.error').length) {
                                $save.removeClass('disabled exceeded-limit').attr('disabled', false);
                                $form.find('.errors.exceeded-limit').remove();
                            }
                        }
                    } else {
                        if (window.charLimit !== -1 && textContent.length > window.charLimit) {
                            const trimmed = content.substring(0, window.charLimit);
                            editor.setContent(trimmed, { format: 'html' });
                            alert(`You have exceeded the limit of ${window.charLimit} characters.`);
                            return;
                        } else if (window.wordLimit !== -1) {
                            const words = textContent.match(/\S+/g) || [];
                            if (words.length > window.wordLimit) {
                                const allowedWords = words.slice(0, window.wordLimit).join(' ');
                                editor.setContent(allowedWords, { format: 'html' });
                                alert(`You have exceeded the limit of ${window.wordLimit} words.`);
                                return;
                            }
                        }
                    }
                }

                editor.on('init', function () {
                    setTimeout(checkCounts, 0);
                });

                const debounced = debounce(checkCounts, 80);
                editor.on('input',      debounced);
                editor.on('keyup',      debounced);
                editor.on('paste',      () => setTimeout(checkCounts, 0));
                editor.on('change',     debounced);
                editor.on('SetContent', debounced);
                editor.on('NodeChange', debounced);
            }
        });
    }

    function debounce(fn, wait) {
        let t;
        return function () {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, arguments), wait);
        };
    }

}